"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SiteUrls_1 = require("@tableau/shared-urls/lib/src/SiteUrls");
var React = require("react");
var reselect_1 = require("reselect");
var globalTypes_1 = require("../../gen-src/queries/globalTypes");
var UrlSearchFunctions_1 = require("../urls/UrlSearchFunctions");
var UrlSearchProvider_1 = require("../urls/UrlSearchProvider");
var OrderBy_1 = require("./OrderBy");
var SortProviderProps_1 = require("./SortProviderProps");
function getFieldAndDirectionFromQueryParam(queryParamValue, validFields) {
    var parts = queryParamValue.split(':');
    if (parts.length !== 2) {
        return null;
    }
    var validField = validateValue(parts[0], validFields);
    var validDirection = validateValue(parts[1], globalTypes_1.OrderDirection);
    if (validField && validDirection) {
        return { field: validField, direction: validDirection };
    }
    else {
        return null;
    }
}
exports.getFieldAndDirectionFromQueryParam = getFieldAndDirectionFromQueryParam;
function constructNewSearchForSortOrder(search, sortOrder) {
    var paramValuesMap = UrlSearchFunctions_1.searchToParamValuesMap(search);
    if (paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.order]) {
        delete paramValuesMap[SiteUrls_1.CatalogUrlParamKeys.order];
    }
    if (sortOrder) {
        var encode = false; // don't encode the colon
        UrlSearchFunctions_1.setParamValues(paramValuesMap, SiteUrls_1.CatalogUrlParamKeys.order, [constructOrderParamValue(sortOrder)], encode);
    }
    return UrlSearchFunctions_1.paramValuesMapToSearch(paramValuesMap);
}
exports.constructNewSearchForSortOrder = constructNewSearchForSortOrder;
function constructOrderParamValue(sortOrder) {
    return sortOrder.field.toLowerCase() + ":" + sortOrder.direction.toLowerCase();
}
exports.constructOrderParamValue = constructOrderParamValue;
/**
 * Validates that the value is valid and returns the valid/normalized version of the value, or else returns null.
 * We rely on the fact that GraphQL generates enum types where the keys and values are the same,
 * and that they're always in all caps.
 */
function validateValue(value, validFields) {
    // Because all the values in the GraphQL enums are in all caps, we "normalize" the user input to uppercase
    var uppercaseValue = value.toUpperCase();
    if (uppercaseValue in validFields) {
        return uppercaseValue;
    }
    else {
        return null;
    }
}
exports.validateValue = validateValue;
var UrlSortProvider = /** @class */ (function (_super) {
    __extends(UrlSortProvider, _super);
    function UrlSortProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UrlSortProvider.prototype.render = function () {
        var _this = this;
        return (React.createElement(UrlSearchProvider_1.UrlSearchProvider, null, function (urlSearch) { return React.createElement(UrlSortProviderInternal, __assign({ urlSearch: urlSearch }, _this.props)); }));
    };
    return UrlSortProvider;
}(React.Component));
exports.UrlSortProvider = UrlSortProvider;
var UrlSortProviderInternal = /** @class */ (function (_super) {
    __extends(UrlSortProviderInternal, _super);
    function UrlSortProviderInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable:typedef
        _this.memoizedGetFieldAndDirectionFromQueryParam = reselect_1.defaultMemoize(getFieldAndDirectionFromQueryParam);
        _this.memoizedBuildDefaultOrder = reselect_1.defaultMemoize(SortProviderProps_1.buildDefaultOrder);
        _this.getParsedOrderOrDefault = function () {
            var sortQueryParamValue = UrlSearchFunctions_1.getSingleParamValue(_this.props.urlSearch.value, SiteUrls_1.CatalogUrlParamKeys.order);
            var defaultDirections = _this.props.validOrderFieldsWithDefaultDirections;
            var parsedSort = _this.memoizedGetFieldAndDirectionFromQueryParam(sortQueryParamValue, defaultDirections);
            return parsedSort || _this.getDefaultOrder();
        };
        _this.clearOrderInUrlIfInvalidOrDefault = function () {
            var parsedOrderOrDefault = _this.getParsedOrderOrDefault();
            if (OrderBy_1.isOrderByEqual(parsedOrderOrDefault, _this.getDefaultOrder())) {
                var newSearch = constructNewSearchForSortOrder(_this.props.urlSearch.value, null);
                _this.props.urlSearch.update(newSearch);
            }
        };
        _this.updateOrderInUrl = function (sortField) {
            var validatedSortField = validateValue(sortField, _this.props.validOrderFieldsWithDefaultDirections);
            if (validatedSortField === null) {
                return;
            }
            var currentOrder = _this.getParsedOrderOrDefault();
            var newOrder;
            if (currentOrder && currentOrder.field === sortField) {
                newOrder = {
                    direction: currentOrder.direction === globalTypes_1.OrderDirection.ASC ? globalTypes_1.OrderDirection.DESC : globalTypes_1.OrderDirection.ASC,
                    field: validatedSortField,
                };
            }
            else {
                newOrder = {
                    direction: _this.props.validOrderFieldsWithDefaultDirections[validatedSortField],
                    field: validatedSortField,
                };
            }
            var newSearch = constructNewSearchForSortOrder(_this.props.urlSearch.value, newOrder);
            _this.props.urlSearch.update(newSearch);
        };
        return _this;
    }
    // tslint:enable:typedef
    UrlSortProviderInternal.prototype.render = function () {
        return this.props.children({
            orderBy: this.getParsedOrderOrDefault(),
            updateSortOrder: this.updateOrderInUrl,
        });
    };
    UrlSortProviderInternal.prototype.componentDidMount = function () {
        this.clearOrderInUrlIfInvalidOrDefault();
    };
    UrlSortProviderInternal.prototype.componentDidUpdate = function () {
        this.clearOrderInUrlIfInvalidOrDefault();
    };
    UrlSortProviderInternal.prototype.getDefaultOrder = function () {
        return this.memoizedBuildDefaultOrder(this.props.defaultField, this.props.validOrderFieldsWithDefaultDirections);
    };
    return UrlSortProviderInternal;
}(React.Component));
exports.UrlSortProviderInternal = UrlSortProviderInternal;
//# sourceMappingURL=UrlSortProvider.js.map